/** Lưới lợi ích của App (nội dung ở download-app-content.js). */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PERKS } from "../download-app-content";

export default function DownloadPerksSection() {
    return (
        <div className="px-4 mt-7">
            <h2 className="font-bold text-lg mb-3 text-center md:text-left">Vì sao nên dùng App?</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {PERKS.map((p) => (
                    <div key={p.title} className="flex md:flex-col items-start gap-3 bg-surface rounded-2xl p-4 border border-line shadow-sm">
                        <div className={`w-11 h-11 shrink-0 rounded-2xl ${p.bg} ${p.color} flex items-center justify-center text-lg`}>
                            <FontAwesomeIcon icon={p.icon} />
                        </div>
                        <div>
                            <p className="font-bold text-sm">{p.title}</p>
                            <p className="text-xs text-content-3 mt-1 leading-relaxed">{p.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
